import HttpClient from "../helpers/HttpClient"
import { isError } from "../helpers/Error"
import AccountLimit, { AccountLimitDto } from "./AccountLimit"

class AccountLimitService {
    httpClient: HttpClient<AccountLimit, AccountLimitDto> = new HttpClient<AccountLimit, AccountLimitDto>(AccountLimit)

    async Get(): Promise<AccountLimit> {
        const res = await this.httpClient.get("/account-limits")
        if (isError(res)) {
            throw new Error(res.message)
        }
        return (res as AccountLimit)
    }

}

const instance = new AccountLimitService()
export default instance


// WEBPACK FOOTER //
// ./src/state/account-limit/AccountLimitService.ts